import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';

import {IAirNoteSet, ITriggerEventSet} from '../';
import {AwairNotifications, PagedAwairGroupedNotifications} from '../models/awair-notifications.model';
import {NotificationSetting} from './../interfaces/notification-setting';
import {environment} from 'environments/environment';

import {chain} from 'lodash';
import * as moment from 'moment';
import {Moment} from 'moment';

import {Observable, of, pipe, Subject, timer} from 'rxjs';

import {AirComponentType, DeviceType, TemperatureUnit} from '../../../shared';
import {Simple200Response} from '../../../afb-api/models/general';
import {Airnote} from '../../../afb-api/models/airnote';
import {TriggerEvent} from '../../../afb-api/models/trigger-event';
import {NotificationType} from '../../../afb-api/enums/notification-type.enum';
import {map, mergeMap, timeInterval} from 'rxjs/internal/operators';
import {flatMap} from 'tslint/lib/utils';

@Injectable()
export class NotificationService {

  private airNoteAnnounced = new Subject<Airnote>();
  airNoteAnnounced$ = this.airNoteAnnounced.asObservable();
  private notificationMsgClosed = new Subject<void>();
  notificationMsgClosed$ = this.notificationMsgClosed.asObservable();

  constructor(private httpClient: HttpClient) {
  }

  getNotificationsByGroupedDay(orgToken: string, fromDate?: Moment, toDate?: Moment): Observable<any> {
    const headers = new HttpHeaders({'Authorization': `Bearer ${orgToken}`});
    const url = `${environment.afbV2Host}org-users/self/timeline`;
    const params = {
      limit: '1000',
      order_by: 'updated_at',
      to: toDate != null ? toDate.utc().toISOString() : moment().utc().toISOString(),
      ...fromDate != null && {from: fromDate.utc().toISOString()}
    };

    return timer(1, 30000).pipe(
      timeInterval(),
      mergeMap(() => this.httpClient.get(url, {headers, params}).pipe(
        map((notificationListObj: AwairNotifications) => {
            const newData = chain(notificationListObj.data)
              .groupBy(noti => moment(noti.updatedAt).calendar(null, {
                sameDay: '[Today,] D MMMM',
                nextDay: 'D MMMM',
                nextWeek: 'D MMMM',
                lastDay: 'D MMMM',
                lastWeek: 'D MMMM',
                sameElse: 'D MMMM'
              }))
              .map((v, i) => {
                return {
                  date: i,
                  notifications: v
                };
              })
              .value();
            return Object.assign(new PagedAwairGroupedNotifications(), {
              data: newData,
              pagination: notificationListObj.pagination
            });
          })
      ))
    );
        // .map((notificationListObj: AwairNotifications) => {
        //   const newData = chain(notificationListObj.data)
        //     .groupBy(noti => moment(noti.updatedAt).calendar(null, {
        //       sameDay: '[Today,] D MMMM',
        //       nextDay: 'D MMMM',
        //       nextWeek: 'D MMMM',
        //       lastDay: 'D MMMM',
        //       lastWeek: 'D MMMM',
        //       sameElse: 'D MMMM'
        //     }))
        //     .map((v, i) => {
        //       return {
        //         date: i,
        //         notifications: v
        //       };
        //     })
        //     .value();
        //   return Object.assign(new PagedAwairGroupedNotifications(), {
        //     data: newData,
        //     pagination: notificationListObj.pagination
        //   });
        // }))
    // )
      // .timer(1, 30000)
      // .timeInterval()
      // .flatMap(() => this.httpClient.get(url, {headers, params})
      //   .map((notificationListObj: AwairNotifications) => {
      //     const newData = chain(notificationListObj.data)
      //       .groupBy(noti => moment(noti.updatedAt).calendar(null, {
      //         sameDay: '[Today,] D MMMM',
      //         nextDay: 'D MMMM',
      //         nextWeek: 'D MMMM',
      //         lastDay: 'D MMMM',
      //         lastWeek: 'D MMMM',
      //         sameElse: 'D MMMM'
      //       }))
      //       .map((v, i) => {
      //         return {
      //           date: i,
      //           notifications: v
      //         };
      //       })
      //       .value();
      //     return Object.assign(new PagedAwairGroupedNotifications(), {
      //       data: newData,
      //       pagination: notificationListObj.pagination
      //     });
      //   })
      // );

    // return pipe(
    //   timer(1, 30000),
    //   timeInterval(),
    //   flatMap(() => this.httpClient.get(url, {headers, params}).pipe(
    //     map((notificationListObj: AwairNotifications) => {
    //       const newData = chain(notificationListObj.data)
    //         .groupBy(noti => moment(noti.updatedAt).calendar(null, {
    //           sameDay: '[Today,] D MMMM',
    //           nextDay: 'D MMMM',
    //           nextWeek: 'D MMMM',
    //           lastDay: 'D MMMM',
    //           lastWeek: 'D MMMM',
    //           sameElse: 'D MMMM'
    //         }))
    //         .map((v, i) => {
    //           return {
    //             date: i,
    //             notifications: v
    //           };
    //         })
    //         .value();
    //       return Object.assign(new PagedAwairGroupedNotifications(), {
    //         data: newData,
    //         pagination: notificationListObj.pagination
    //       });
    //     })
    //   ))
    // );
        // .map((notificationListObj: AwairNotifications) => {
        //   const newData = chain(notificationListObj.data)
        //     .groupBy(noti => moment(noti.updatedAt).calendar(null, {
        //       sameDay: '[Today,] D MMMM',
        //       nextDay: 'D MMMM',
        //       nextWeek: 'D MMMM',
        //       lastDay: 'D MMMM',
        //       lastWeek: 'D MMMM',
        //       sameElse: 'D MMMM'
        //     }))
        //     .map((v, i) => {
        //       return {
        //         date: i,
        //         notifications: v
        //       };
        //     })
        //     .value();
        //   return Object.assign(new PagedAwairGroupedNotifications(), {
        //     data: newData,
        //     pagination: notificationListObj.pagination
        //   });
        // }))
    // )
      // .timer()
      // .timeInterval()
      // .flatMap(() => this.httpClient.get(url, {headers, params})
      //   .map((notificationListObj: AwairNotifications) => {
      //     const newData = chain(notificationListObj.data)
      //       .groupBy(noti => moment(noti.updatedAt).calendar(null, {
      //         sameDay: '[Today,] D MMMM',
      //         nextDay: 'D MMMM',
      //         nextWeek: 'D MMMM',
      //         lastDay: 'D MMMM',
      //         lastWeek: 'D MMMM',
      //         sameElse: 'D MMMM'
      //       }))
      //       .map((v, i) => {
      //         return {
      //           date: i,
      //           notifications: v
      //         };
      //       })
      //       .value();
      //     return Object.assign(new PagedAwairGroupedNotifications(), {
      //       data: newData,
      //       pagination: notificationListObj.pagination
      //     });
      //   })
      // );
  }

  requestFeed(orgToken: string, orderBy: string, itemType?: string, deviceType?: DeviceType, deviceId?: number,
              component?: string, fromDate?: Date, toDate?: Date,
              desc?: boolean, limit?: number): Observable<Array<Airnote | TriggerEvent>> {

    const headers = new HttpHeaders({'Authorization': `Bearer ${orgToken}`});
    const url: string = `${environment.afbV2Host}org-users/self/timeline`;

    // Set query params
    let params = new HttpParams();
    params = params.append('order_by', orderBy);

    if (itemType) {
      params = params.append('item_type', itemType);
    }
    if (deviceType) {
      params = params.append('device_type', deviceType);
    }
    if (deviceId) {
      params = params.append('device_id', deviceId.toString());
    }
    if (component) {
      params = params.append('component', component);
    }
    if (fromDate) {
      params = params.append('from', fromDate.toISOString());
    }
    if (toDate) {
      params = params.append('to', toDate.toISOString());
    }
    if (desc) {
      params = params.append('desc', desc.toString());
    }
    if (limit) {
      params = params.append('limit', limit.toString());
    }

    const options = {
      headers,
      params
    };

    return this.httpClient
      .get<{ data: Array<Airnote | TriggerEvent> }>(url, options).pipe(
        map(response => response.data)
      );
  }

  requestAirNote(orgToken: string, deviceType: DeviceType, deviceId: string, orderBy: string,
                 component?: string, fromDate?: Date, toDate?: Date, desc?: boolean, limit?: number): Observable<Airnote[]> {

    const headers = new HttpHeaders({'Authorization': `Bearer ${orgToken}`});
    const url: string = `${environment.afbV2Host}org-users/self/timeline`;

    // Set query params
    let params = new HttpParams();
    params = params.append('item_type', NotificationType.Airnote);
    params = params.append('device_type', deviceType);
    params = params.append('device_id', deviceId.toString());
    params = params.append('order_by', orderBy);

    if (component) {
      params = params.append('component', component);
    }
    if (fromDate) {
      params = params.append('from', fromDate.toISOString());
    }
    if (toDate) {
      params = params.append('to', toDate.toISOString());
    }
    if (desc) {
      params = params.append('desc', desc.toString());
    }
    if (limit) {
      params = params.append('limit', limit.toString());
    }

    const options = {
      headers,
      params
    };

    return this.httpClient
      .get<{ data: Airnote[] }>(url, options).pipe(
        map(response => response.data)
      );
  }

  requestTriggerEvent(orgToken: string, deviceType: DeviceType, deviceId: string, orderBy: string,
                      component?: string, fromDate?: Date, toDate?: Date, desc?: boolean, limit?: number): Observable<TriggerEvent[]> {

    const headers = new HttpHeaders({'Authorization': `Bearer ${orgToken}`});
    const url: string = `${environment.afbV2Host}org-users/self/timeline`;

    // Set query params
    let params = new HttpParams();
    params = params.append('item_type', 'air-trigger-event');
    params = params.append('device_type', deviceType);
    params = params.append('device_id', deviceId.toString());
    params = params.append('order_by', orderBy);

    if (component) {
      params = params.append('component', component);
    }
    if (fromDate) {
      params = params.append('from', fromDate.toISOString());
    }
    if (toDate) {
      params = params.append('to', toDate.toISOString());
    }
    if (desc) {
      params = params.append('desc', desc.toString());
    }
    if (limit) {
      params = params.append('limit', limit.toString());
    }

    const options = {
      headers,
      params
    };

    return this.httpClient
      .get<{ data: TriggerEvent[] }>(url, options).pipe(
        map(response => response.data)
      );
  }

  airNoteListToSet(airNoteList: Airnote[], tempUnit: TemperatureUnit): IAirNoteSet {
    const airNoteSet: IAirNoteSet = {
      score: [],
      temp: [],
      humid: [],
      co2: [],
      voc: [],
      dust: [],
      pm25: []
    };

    if (tempUnit === TemperatureUnit.Celsius) {
      for (let i = 0; i < airNoteList.length; i++) {
        airNoteSet[airNoteList[i].component].push(airNoteList[i]);
      }
    } else {
      // Convert to fahrenheit if settings for temperature unit is set to fahrenheit
      for (let i = 0; i < airNoteList.length; i++) {
        airNoteSet[airNoteList[i].component].push(airNoteList[i]);
      }
    }

    return airNoteSet;
  }

  triggerEventListToSet(triggerEventList: TriggerEvent[], tempUnit: TemperatureUnit): ITriggerEventSet {
    const triggerEventSet: ITriggerEventSet = {
      score: [],
      temp: [],
      humid: [],
      co2: [],
      voc: [],
      dust: [],
      pm25: []
    };

    if (tempUnit === TemperatureUnit.Celsius) {
      for (let i = 0; i < triggerEventList.length; i++) {
        triggerEventSet[triggerEventList[i].component].push(triggerEventList[i]);
      }
    } else {
      // Convert to fahrenheit if settings for temperature unit is set to fahrenheit
      for (let i = 0; i < triggerEventList.length; i++) {
        triggerEventSet[triggerEventList[i].component].push(triggerEventList[i]);
      }
    }

    return triggerEventSet;
  }

  announceAirNote(airNote: Airnote): void {
    this.airNoteAnnounced.next(airNote);
  }

  /**
   * Notification Settings
   *
   */

  getNotificationSettings(orgToken: string, deviceType: string, deviceId: string): Observable<NotificationSetting[]> {
    const headers = new HttpHeaders({'Authorization': `Bearer ${orgToken}`});
    const url: string = `${environment.afbV2Host}org-users/self/devices/${deviceType}/${deviceId}/notification-settings`;

    return this.httpClient
      .get<{ data: NotificationSetting[] }>(url, {headers}).pipe(
        map(response => response.data)
      );
  }

  putNotificationSettings(orgToken: string, deviceType: string, deviceId: string,
                          notificationSettingList: NotificationSetting[]): Observable<Simple200Response | void> {
    const headers = new HttpHeaders({'Authorization': `Bearer ${orgToken}`});
    const url: string = `${environment.afbV2Host}org-users/self/devices/${deviceType}/${deviceId}/notification-settings`;

    const copyNotificationSettingList: NotificationSetting[] = notificationSettingList.filter(
      this.filterNotificationSettingByDeviceType(<DeviceType>deviceType)
    );

    const body = {
      settings: [...copyNotificationSettingList]
    };

    return this.httpClient
      .put<Simple200Response>(url, body, {headers});
  }

  filterNotificationSettingByDeviceType(deviceType: DeviceType): (NotificationSetting) => boolean {
    return (notificationSetting: NotificationSetting) => {
      const airComponent: AirComponentType = <AirComponentType>notificationSetting.comp;
      if (deviceType === DeviceType.Glow
        && airComponent !== AirComponentType.Dust
        && airComponent !== AirComponentType.PM25) {
        return true;
      } else if (deviceType === DeviceType.Awair
        && airComponent !== AirComponentType.PM25) {
        return true;
      } else if ((deviceType === DeviceType.Omni || deviceType === DeviceType.Mint)
        && airComponent !== AirComponentType.Dust) {
        return true;
      } else {
        return false;
      }
    }
  }
}
